import { render, staticRenderFns } from "./BluenetPaymentMethods.vue?vue&type=template&id=070c6986"
import script from "./BluenetPaymentMethods.vue?vue&type=script&lang=js"
export * from "./BluenetPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports